export const AMEX_UNBIND_PARAM_ERROR = 'INVALID_PARAMETER';
export const AMEX_UNBIND_COOKIE_ERROR = 'NO_COOKIE_EXISTS';
// The following 3 enums are needed by identityLookup in the VSB use cases to validate email at orch level
export const CONSUMER_ID_MISSING = 'CONSUMER_ID_MISSING';
export const ID_FORMAT_UNSUPPORTED = 'ID_FORMAT_UNSUPPORTED';
export const SUPPORTED_NETWORK_ERROR = {
  message: 'Failed to fetch supported network details',
  reason: 'Invalid request'
};
export const VSB_UNBIND_ERROR = {
  message: 'Failed to invoke unbind',
  reason: 'AUTH_INVALID'
};
